/**
 * The front door's screens, where the game can find them (step 96).
 *
 * The title and the create screen are built by `main.js` the moment the page
 * runs, long before `game.js` — three.js, both bodies, the clips — has
 * arrived. The game lists every screen on `window.__FIGHTGAME__.screens` for
 * the harnesses, so it needs these two as well; this is the one place both
 * modules import, and so the one instance both of them see.
 */
export const front = {
  title: null,
  create: null,
  gate: null,
};
